export default __webpack_public_path__ + "static/media/sword.0f9fcbf3.png";